<template>
    <base-nav
        container-classes="container-fluid"
        class="navbar-top border-bottom navbar-expand"
        :class="{ 'navbar-light': type === 'default' }"
    >
        <button @click.prevent="this.$router.back();" @mouseenter="hoverButton = true" @mouseleave="hoverButton = false"
                title="Zurück" class="btn btn-small d-none d-xl-inline-block"
                :class="{'btn-secondary': hoverButton}"><span
            class="fad fa-angle-double-left pr-2"></span> Zurück
        </button>
        <div class="nav-item d-xl-none">
            <!-- Sidenav toggler -->
            <div
                class="pr-3 sidenav-toggler"
                :class="{
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light'
          }"
                @click="toggleSidebar"
            >
                <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                </div>
            </div>
        </div>
        <!-- Search form -->
        <!--    <form onsubmit="return false;"
              class="navbar-search form-inline mr-sm-3"
              :class="{
                'navbar-search-light': type === 'default',
                'navbar-search-dark': type === 'light',
              }"
              id="navbar-search-main"
            >
              <div class="form-group mb-0">
                <div class="input-group input-group-alternative input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fad fa-search"></i></span>
                  </div>
                  <input class="form-control" placeholder="Suche (noch nicht aktiv)" type="text" />
                </div>
              </div>
              <button
                type="button"
                class="close"
                data-action="search-close"
                data-target="#navbar-search-main"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </form>-->
        <!-- Navbar links -->
        <ul class="navbar-nav align-items-center ml-md-auto">

            <li class="nav-item d-sm-none">
                <a
                    class="nav-link"
                    href="#"
                    data-action="search-show"
                    data-target="#navbar-search-main"
                >
                    <!--                    <i class="ni ni-zoom-split-in"></i>-->
                </a>
            </li>
            <!--      <base-dropdown
                    class="nav-item"
                    tag="li"
                    title-classes="nav-link"
                    title-tag="a"
                    icon="fad fa-bell"
                    menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
                  >
                    &lt;!&ndash; Dropdown header &ndash;&gt;
                    <div class="px-3 py-3">
                      <h6 class="text-sm text-muted m-0">
                        You have <strong class="text-primary">13</strong> notifications.
                      </h6>
                    </div>
                    &lt;!&ndash; List group &ndash;&gt;
                    <div class="list-group list-group-flush">
                      <a href="#!" class="list-group-item list-group-item-action">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            &lt;!&ndash; Avatar &ndash;&gt;
                            <img
                              alt="Image placeholder"
                              src="img/theme/team-1.jpg"
                              class="avatar rounded-circle"
                            />
                          </div>
                          <div class="col ml&#45;&#45;2">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <h4 class="mb-0 text-sm">John Snow</h4>
                              </div>
                              <div class="text-right text-muted">
                                <small>2 hrs ago</small>
                              </div>
                            </div>
                            <p class="text-sm mb-0">
                              Let's meet at Starbucks at 11:30. Wdyt?
                            </p>
                          </div>
                        </div>
                      </a>
                      <a href="#!" class="list-group-item list-group-item-action">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            &lt;!&ndash; Avatar &ndash;&gt;
                            <img
                              alt="Image placeholder"
                              src="img/theme/team-2.jpg"
                              class="avatar rounded-circle"
                            />
                          </div>
                          <div class="col ml&#45;&#45;2">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <h4 class="mb-0 text-sm">John Snow</h4>
                              </div>
                              <div class="text-right text-muted">
                                <small>3 hrs ago</small>
                              </div>
                            </div>
                            <p class="text-sm mb-0">
                              A new issue has been reported for Argon.
                            </p>
                          </div>
                        </div>
                      </a>
                      <a href="#!" class="list-group-item list-group-item-action">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            &lt;!&ndash; Avatar &ndash;&gt;
                            <img
                              alt="Image placeholder"
                              src="img/theme/team-3.jpg"
                              class="avatar rounded-circle"
                            />
                          </div>
                          <div class="col ml&#45;&#45;2">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <h4 class="mb-0 text-sm">John Snow</h4>
                              </div>
                              <div class="text-right text-muted">
                                <small>5 hrs ago</small>
                              </div>
                            </div>
                            <p class="text-sm mb-0">Your posts have been liked a lot.</p>
                          </div>
                        </div>
                      </a>
                      <a href="#!" class="list-group-item list-group-item-action">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            &lt;!&ndash; Avatar &ndash;&gt;
                            <img
                              alt="Image placeholder"
                              src="img/theme/team-4.jpg"
                              class="avatar rounded-circle"
                            />
                          </div>
                          <div class="col ml&#45;&#45;2">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <h4 class="mb-0 text-sm">John Snow</h4>
                              </div>
                              <div class="text-right text-muted">
                                <small>2 hrs ago</small>
                              </div>
                            </div>
                            <p class="text-sm mb-0">
                              Let's meet at Starbucks at 11:30. Wdyt?
                            </p>
                          </div>
                        </div>
                      </a>
                      <a href="#!" class="list-group-item list-group-item-action">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            &lt;!&ndash; Avatar &ndash;&gt;
                            <img
                              alt="Image placeholder"
                              src="img/theme/team-5.jpg"
                              class="avatar rounded-circle"
                            />
                          </div>
                          <div class="col ml&#45;&#45;2">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <h4 class="mb-0 text-sm">John Snow</h4>
                              </div>
                              <div class="text-right text-muted">
                                <small>3 hrs ago</small>
                              </div>
                            </div>
                            <p class="text-sm mb-0">
                              A new issue has been reported for Argon.
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                    &lt;!&ndash; View all &ndash;&gt;
                    <a
                      href="#!"
                      class="dropdown-item text-center text-primary font-weight-bold py-3"
                      >View all</a
                    >
                  </base-dropdown>-->
            <!--      <base-dropdown
                    menu-classes="dropdown-menu-lg dropdown-menu-dark bg-default dropdown-menu-right"
                    class="nav-item"
                    tag="li"
                    title-tag="a"
                    title-classes="nav-link"
                    icon="fad fa-object-ungroup"
                  >
                    <div class="row shortcuts px-4">
                      <a href="#!" class="col-4 shortcut-item">
                        <span class="shortcut-media avatar rounded-circle bg-gradient-red">
                          <i class="fad fa-calendar-alt"></i>
                        </span>
                        <small>Calendar</small>
                      </a>
                      <a href="#!" class="col-4 shortcut-item">
                        <span
                          class="shortcut-media avatar rounded-circle bg-gradient-orange"
                        >
                          <i class="fad fa-envelope-open-text"></i>
                        </span>
                        <small>Email</small>
                      </a>
                      <a href="#!" class="col-4 shortcut-item">
                        <span class="shortcut-media avatar rounded-circle bg-gradient-info">
                          <i class="fad fa-credit-card"></i>
                        </span>
                        <small>Payments</small>
                      </a>
                      <a href="#!" class="col-4 shortcut-item">
                        <span
                          class="shortcut-media avatar rounded-circle bg-gradient-green"
                        >
                          <i class="fad fa-chart-pie"></i>
                        </span>
                        <small>Reports</small>
                      </a>
                      <a href="#!" class="col-4 shortcut-item">
                        <span
                          class="shortcut-media avatar rounded-circle bg-gradient-purple"
                        >
                          <i class="fad fa-map-marker-alt"></i>
                        </span>
                        <small>Maps</small>
                      </a>
                      <a href="#!" class="col-4 shortcut-item">
                        <span
                          class="shortcut-media avatar rounded-circle bg-gradient-yellow"
                        >
                          <i class="fad fa-shopping-basket"></i>
                        </span>
                        <small>Shop</small>
                      </a>
                    </div>
                  </base-dropdown>-->
        </ul>
        <button class="help-button" @click.prevent="$router.push('/help')">
            <i class="fa-regular fa-circle-question help-icon"></i>
        </button>
        <ul v-if="!currentUser" class="navbar-nav align-items-center ml-auto ml-md-0">
            <li class="nav-item">
                <a class="nav-link" href @click.prevent="logIn">
                    Login
                </a>
            </li>
        </ul>
        <ul v-if="currentUser" class="navbar-nav align-items-center ml-auto ml-md-0">
            <base-dropdown
                v-if="clients.length > 1"
                class="nav-item"
                tag="li"
                title-classes="nav-link"
                title-tag="a"
                icon="fad fa-users"
                menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
            >
                <!-- Dropdown header -->
                <div class="px-3 py-3">
                    <h6 class="text-sm text-muted m-0">
                        Mandant: <strong>{{ client }}</strong> ausgewählt.
                    </h6>
                    <span class="text-sm">Zum wechseln bitte gewünschten Mandanten wählen</span>
                </div>
                <div class="dropdown-divider mt-0 mb-0"></div>
                <!-- List group -->
                <div class="list-group list-group-flush">
                    <a @click.stop="switchUser(client.id)" v-for="(client, key) in clients" href="#" :class="client.id === currentUser.clientId ? 'active': ''" class="list-group-item list-group-item-action">
                        <div class="row align-items-center">
                            <div class="col col-auto">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 :class="client.id === currentUser.clientId ? 'text-white': ''" class="mb-0 text-sm">{{ (client.firstname) ? client.firstname + " " + client.lastName : client.lastName }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </base-dropdown>
            <base-dropdown
                menu-on-right
                class="nav-item"
                tag="li"
                title-tag="a"
                title-classes="nav-link pr-0">

                <template v-slot:title-container>
                    <a href="#" class="nav-link pr-0" @click.prevent>
                        <div class="media align-items-center">
                            <span class="avatar avatar-sm rounded-circle">
                                <img alt="avatar" title="Avatar"
                                     :src="'https://eu.ui-avatars.com/api/?name=' + currentUser.given_name + ' ' + currentUser.family_name + '&background=000&color=fff'"/>
                            </span>
                            <div class="media-body ml-2 d-none d-lg-block">
                                <span class="mb-0 text-sm font-weight-bold">{{ currentUser.name }}</span>
                            </div>
                        </div>
                    </a>
                </template>

                <div class="dropdown-header noti-title">
                    <h6 class="text-overflow m-0">Willkommmen!</h6>
                </div>
                <a href="#!" class="dropdown-item" @click.prevent="$router.push('/contacts')">
                    <i class="fad fa-address-book"></i>
                    <span>Profil</span>
                </a><!--
        <a href="#!" class="dropdown-item">
          <i class="ni ni-settings-gear-65"></i>
          <span>Einstellungen</span>
        </a>
        <a href="#!" class="dropdown-item">
          <i class="fad fa-calendar-alt"></i>
          <span>Aktivitäten</span>
        </a>
        <a href="#!" class="dropdown-item">
          <i class="ni ni-support-16"></i>
          <span>Support</span>
        </a>-->
                <div class="dropdown-divider"></div>
                <a href="#!" class="dropdown-item" @click.prevent="logOut">
                    <i class="fad fa-sign-out"></i>
                    <span>Logout</span>
                </a>
            </base-dropdown>
        </ul>
    </base-nav>
</template>

<style>
.help-button {
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    overflow: hidden;
    width: 30px;
}

.help-icon {
    font-size: 1.2rem;
    color: black;
}

</style>
<script>
import BaseNav from "@/components/Navbar/BaseNav";
import BaseButton from "../../components/BaseButton";
import UserService from '@/services/user.service';

export default {
    components: {
        BaseButton,
        BaseNav,
    },
    props: {
        type: {
            type: String,
            default: "default", // default|light
            description:
                "Look of the dashboard navbar. Default (Green) or light (gray)",
        },
    },
    computed: {
        routeName() {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    data() {
        return {
            error: '',
            client: '',
            clients: [],
            activeNotifications: false,
            showMenu: false,
            searchModalVisible: false,
            searchQuery: "",
            hoverButton: false,
        };
    },
    created(){
        this.getClients();
    },
    methods: {
        getClients(){
            if(this.currentUser && this.currentUser.clientIds) {
                const ids = this.currentUser.clientIds;
                ids.forEach(entry => {
                    UserService.getCustomer(entry).then(
                        response => {
                            this.clients.push(response.data);
                            if(this.currentUser.clientId === response.data.id) {
                                this.client = (response.data.firstname) ? response.data.firstname + " " + response.data.lastName : response.data.lastName;
                            }
                        },
                        error => {
                            this.getError(error);
                        }
                    );
                });
            }
        },
        switchUser(id) {
            UserService.switchClient(id).then(
                response => {
                    this.client = (response.data.firstname) ? response.data.firstname + " " + response.data.lastName : response.data.lastName;
                    if(this.routeName !== 'Benutzer' && this.routeName !== 'Meldungen' && this.routeName !== 'Lizenzen' && this.routeName !== 'Formulare') {
                        window.location.reload();
                    } else {
                        window.location.href = '/dashboard';
                    }
                },
                error => {
                    this.getError(error);
                }
            );
        },
        getError(error) {
            if (error.response && error.response.status === '401') {
                this.error = 'you are not logged in!';
            } else if (error.response && error.response.status === '403') {
                this.error = 'you are not permitted!';
            } else {
                this.error =
                    (error.response && error.response.data) ||
                    error.message ||
                    error.toString();
            }
        },
        logIn() {
            this.$store.dispatch('auth/login');
        },
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/');
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
    },
};
</script>
